import React from 'react'
import './Home.css'
import { Button, Stack, Typography } from '@mui/material'
import { TrendingFlat } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import BlockFullMain from 'src/components/Common/BlockFullMain'

export default function HomeBlackFriday() {
  return (
    <BlockFullMain
      iconImage='https://meteor.stullercloud.com/das/136871401?fmt=smart-alpha&hei=64'
      altIcon='MatrixGold and CounterSketch'
      iconImageSx={{ height: { xs: 32, sm: 40 } }}
      title='blackFriday.title'
      bgColor='#090d16'
      image='https://meteor.stullercloud.com/das/140116168'
      altImage='Yellow Gold ring with diamond accent stones and black princesses, black center diamond and honeycomb golden filigree in a scattered crystal dark background.'
    >
      <Stack sx={{ alignItems: 'flex-start', gap: 2, mt: -2 }}>
        <Typography sx={{ fontSize: '1.1rem', fontWeight: 500 }}>
          <FormattedMessage
            id='blackFriday.description'
            values={{
              ContactSales: (
                <Link to='/sales'>
                  <FormattedMessage id='sales.title' />
                </Link>
              )
            }}
          />
        </Typography>
        <Typography sx={{ fontSize: '1.1rem', fontWeight: 500 }}>
          <FormattedMessage id='blackFriday.date' />
        </Typography>
        <Button
          size='large'
          variant='contained'
          component={Link}
          to='/store'
          endIcon={<TrendingFlat />}
          data-cy='home-banner-button'
          sx={{ mt: 3 }}
        >
          <FormattedMessage id='common.buyNow' />
        </Button>
      </Stack>
    </BlockFullMain>
  )
}
